import { clientLogger } from "@/src/utils/observability/client-logger";

/**
 * Exception wrapper for local storage value storage.
 * Also dispatches a storage event to notify listeners of the change.
 * */
export const storeValueInLocalStorage = (
  key: string | undefined,
  value: string,
): void => {
  if (typeof window !== "undefined" && key) {
    try {
      localStorage.setItem(key, value);
      window.dispatchEvent(new Event("storage"));
    } catch (error) {
      clientLogger.warn({
        event: "storage.local_set_failed",
        error,
        attributes: { key },
      });
    }
  } else {
    clientLogger.warn({
      event: "storage.local_unavailable",
      attributes: { key },
    });
  }
};

/**
 * Exception wrapper for local storage value fetch.
 * */
export const getValueFromLocalStorage = (key: string): string | undefined => {
  if (typeof window !== "undefined") {
    try {
      return localStorage.getItem(key) ?? undefined;
    } catch (error) {
      clientLogger.warn({
        event: "storage.local_get_failed",
        error,
        attributes: { key },
      });
    }
  } else {
    clientLogger.warn({
      event: "storage.local_unavailable",
      attributes: { key },
    });
  }
};
